<template>
<div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
        <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag" v-if="!isSpinnerShow && totalEntries == 0"> {{$t('table.no_records')}}</div>
    <div class="dataTables_wrapper dt-bootstrap4" v-if="!isSpinnerShow && totalEntries != 0">
        <h6 class="text-primary fw-500"><i class="fas fa-store mr-2 text-secondary"></i>{{outlet}}</h6>
        <div class="row justify-content-end mt-2">
            <div class="col-auto pt-2">
                <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
            </div>
            <div class="col-auto">
                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 overflow-auto">
                <b-table small striped hover bordered :fields="fields" :items="inventoryItems" responsive="sm">
                    <template #cell(index)="data">
                        {{ data.index + startPage }}
                    </template>
                    <template #cell(inDate)="data">
                        {{data.item.inDate == null ? '-' : getDate(data.item.inDate)}}
                    </template>
                    <template #cell(outDate)="data">
                        {{data.item.outDate == null ? '-' : getDate(data.item.outDate)}}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {formatDate} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, getOutletName, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'inventory',
    data(){
        return{
            isSpinnerShow: false,
            inventoryItems: [], outletID: 0, itemID: 0, outlet: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "name", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle'},
                { key: "inDate", label: this.$i18n.t('salon_report.stock.stock_in') + this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle'},
                { key: "outDate", label: this.$i18n.t('salon_report.stock.stock_out') + this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle'}
            ]
        },
    },
    methods:{
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1;
                this.getInventory(this.outletID, this.itemID)
            }
        },
        getDate(ts){
            return formatDate(ts);
        },
        getInventory(outletID, id){
            this.outletID = outletID;
            this.itemID = id;

            let $vm = this;
            const QUERY_STRING =  "?page=" + $vm.page;
            const url =  $vm.$api.OUTLET + "/" + this.outletID + $vm.$api.STOCK + "/" + this.itemID + $vm.$api.INVENTORY + QUERY_STRING;

            $vm.isSpinnerShow = true;
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var retData = setReturnData(response.data.result, response.data.count, $vm.page)
                $vm.inventoryItems = retData.result;
                $vm.totalEntries = retData.count;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            $vm.outlet = getOutletName(this.outletID, JSON.parse(this.$store.state.outlets))
        }, 
    }
}
</script>
